import React from 'react';
import './css/RecipeProfile.css';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import founderPhoto from './assets/profile.png';
import SEO from './components/SEO';

const RecipeProfile = () => {
    return (
        <div className="about-page">
            <SEO 
                title="About Savory - Your Personal Recipe Discovery Platform"
                description="Learn about Savory, the AI-powered recipe discovery platform that helps you find nutritionally balanced recipes tailored to your dietary preferences and goals."
                keywords="about savory, recipe discovery platform, AI recipes, nutritional analysis, dietary preferences, healthy cooking"
                url="/recipes-profile"
                type="website"
                breadcrumb={[
                    { name: "Home", url: "/" },
                    { name: "About", url: "/recipes-profile" }
                ]}
            />
            <div className="back-button-container">
                <Link to="/" className="back-button-details">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M19 12H5" stroke="#2D3436" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M12 19L5 12L12 5" stroke="#2D3436" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <span></span>
                </Link>
            </div>

            <div className="about-container">
                <motion.div 
                    className="about-header"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <h1>About Savory</h1>
                </motion.div>

                <motion.div 
                    className="about-content"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                >
                    <div className="about-mission">
                        <div className="mission-text">
                            <h2>Our Mission</h2>
                            <p>
                                Savory is a smart recipe discovery platform founded in early 2025 by George Vashakidze, 
                                a student at IE University. Designed to revolutionize how people find and follow recipes, 
                                Savory combines advanced nutritional filtering, video-to-recipe technology, and step-by-step 
                                guidance to help users cook meals that match their health and dietary goals.
                            </p>
                        </div>
                        <div className="mission-image">
                            <img src={founderPhoto} alt="George Vashakidze" className="founder-photo" />
                            <div className="founder-label">George Vashakidze, Founder</div>
                        </div>
                    </div>

                    <motion.div 
                        className="feature-cards"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.4 }}
                    >
                        <div className="feature-card">
                            <div className="feature-icon">🥗</div>
                            <h3>Nutritional Filtering</h3>
                            <p>Find recipes that match your specific dietary needs and health goals with powerful filtering options.</p>
                        </div>
                        
                        <div className="feature-card">
                            <div className="feature-icon">📹</div>
                            <h3>Video-to-Recipe</h3>
                            <p>Transform your favorite cooking videos into structured, easy-to-follow recipes.</p>
                        </div>
                        
                        <div className="feature-card">
                            <div className="feature-icon">📝</div>
                            <h3>Step-by-Step Guidance</h3>
                            <p>Clear instructions and organized steps make cooking approachable for everyone.</p>
                        </div>
                    </motion.div>

                    <motion.div 
                        className="about-description"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.6 }}
                    >
                        <p>
                            Whether you're tracking calories, avoiding allergens, or just want a better way to cook from YouTube videos, 
                            Savory makes it easier and smarter.
                        </p>
                    </motion.div>

                    <motion.div 
                        className="contact-section"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.8 }}
                    >
                        <h2>Get in Touch</h2>
                        <p>For questions, partnerships, or support, contact us at:</p>
                        <a href="mailto:team@savory.ink" className="contact-button">team@savory.ink</a>
                    </motion.div>
                </motion.div>
            </div>
        </div>
    );
};

export default RecipeProfile;
